var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  ScreenSummaryInvestments: () => ScreenSummaryInvestments
});
var import_yayoyakiValue = __toModule(require("../yayoyakiValue"));
var import_screenSummary = __toModule(require("./screenSummary"));
const totalsYayoyakis = [
  { key: "total_purchase", value: "Y01664" },
  { key: "total_sale", value: "Y01665" },
  { key: "total_performance", value: "Y01663" },
  { key: "total_balance", value: "Y01667" }
];
const totalsYayoyakisByCardGroup = [
  { key: "investments_interests_card", value: "Y01652" },
  { key: "investments_dividends_card", value: "Y01653" },
  { key: "investments_insurance_card", value: "Y01654" },
  { key: "investments_airdrop_card", value: "Y01655" },
  { key: "investments_products_card", value: "Y01656" },
  { key: "investments_shares_card", value: "Y01657" },
  { key: "investments_crypto_card", value: "Y01658" },
  { key: "investments_funds_card", value: "Y01659" },
  { key: "investments_forward_card", value: "Y01660" },
  { key: "investments_suscription_card", value: "Y01661" },
  { key: "other_income_strange_card", value: "Y01662" }
];
class ScreenSummaryInvestments extends import_screenSummary.ScreenSummary {
  constructor(samaData, samaForm, screenName, navigationIndex) {
    super(samaData, samaForm, screenName, navigationIndex);
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.screenName = screenName;
    this.navigationIndex = navigationIndex;
  }
  getTotals(yayoyakis) {
    return yayoyakis.reduce((accumulator, currentValue) => {
      const { key, value } = currentValue;
      accumulator[key] = new import_yayoyakiValue.YayoyakiValue(this.samaData, this.samaForm, this.samaForm.getYayoyakiForm(value)).getValue();
      return accumulator;
    }, {});
  }
  getInvestmentTotals() {
    return this.getTotals(totalsYayoyakis);
  }
  getInvestmentTotalsByCardGroup() {
    return this.getTotals(totalsYayoyakisByCardGroup);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ScreenSummaryInvestments
});
